import { DropdownPopoverOptions } from 'modules/common/components/ToolbarPopover/DropdownPopover';
import { BrandState } from 'modules/User';

/**
 * Get the brands that have brand colors in it,
 * and construct the colors array mapping the brands
 *
 * @param brands brand kit
 * @returns a brand name array used by the dropdown component
 */
export const validateBrands = (brands: Pick<BrandState, 'name' | 'colors'>[]) => {
  const validBrands: DropdownPopoverOptions = [];
  const colors: BrandState['colors'][] = [];

  brands.forEach((brand) => {
    validBrands.push({ value: validBrands.length, label: brand.name || 'My Brand' });
    colors.push(brand.colors);
  });

  return { brands: validBrands, colors };
};
